import { useEffect, useState } from 'react'
import { PerformanceStats, PerfStatsEmitter } from './PerfStatsEmitter'
import { Button } from '@/UIComponents2/Button'

export default function PerfStatsPage() {
    const [perfStats, setPerfStats] = useState<PerformanceStats>(PerfStatsEmitter.state)

    useEffect(() => {
        PerfStatsEmitter.on('changed', (data) => {
            setPerfStats(data)
        })
    }, [])

    return (
        <div style={{ overflow: 'auto', width: 300 }}>
            <div>AppContextDispatchCt: {perfStats.appContextDispatchCt}</div>
            <div>UserContextDispatchCt: {perfStats.userContextDispatchCt}</div>
            <div>RoomContextDispatchCt: {perfStats.roomContextDispatchCt}</div>
            <div>CollaboratePageRenderCt: {perfStats.collaboratePageRenderCt}</div>
            <div>GalleryVideoLayoutRecalcCt: {perfStats.galleryVideoLayoutRecalcCt}</div>

            <Button
                variant="primary"
                onClick={() => {
                    PerfStatsEmitter.reset()
                }}
            >
                Reset
            </Button>
        </div>
    )
}
